import {
  STATUS_FILTER_LABELS,
  overrideLabels,
  resolveOrder,
  type ResourceStatus
} from '@/shared/lib/status'

export type JourneyUiStatus = ResourceStatus

/** Nível não tem `expired` nem `danger`: ou está liberado, em andamento,
 *  concluído, ou bloqueado. Subconjunto explícito do canônico — antes era uma
 *  união literal própria, que sobrevivia a renomeações sem o compilador notar. */
export type LevelUiStatus = Extract<
  ResourceStatus,
  'available' | 'progress' | 'success' | 'locked'
>

/* Jornada e fase são femininas. O canônico carrega a forma masculina, então o
   override é só o delta de concordância — não uma segunda tabela. */
export const JOURNEY_STATUS_LABELS = overrideLabels({
  success: 'Concluída',
  locked: 'Bloqueada',
  expired: 'Encerrada'
})

export const PHASE_STATUS_LABELS = overrideLabels({
  success: 'Concluída',
  locked: 'Bloqueada'
})

/** Jornadas seguem a ordem canônica, sem divergência. */
export const JOURNEY_SORT_PRIORITY = resolveOrder()

/* `new` não é um `ResourceStatus`: recência é eixo independente de progresso.
   Por isso o id do filtro é a união dos dois eixos, não só do vocabulário. */
export type JourneyFilterId =
  | 'all'
  | 'new'
  | Extract<ResourceStatus, 'progress' | 'available' | 'success' | 'locked'>

const FILTER_LABELS = overrideLabels(
  { success: 'Concluídas', locked: 'Bloqueadas' },
  STATUS_FILTER_LABELS
)

export const JOURNEY_FILTERS: {
  id: JourneyFilterId
  label: string
}[] = [
  { id: 'all', label: 'Todas' },
  { id: 'progress', label: FILTER_LABELS.progress },
  { id: 'available', label: FILTER_LABELS.available },
  { id: 'success', label: FILTER_LABELS.success },
  { id: 'locked', label: FILTER_LABELS.locked }
]
